// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2-OQI","content":"Modal_content__3TO5A","title":"Modal_title__1SH87","close":"Modal_close__25Uob"};